import { createFileRoute } from "@tanstack/react-router";
import { Breadcrumbs, TrashView } from "../../components/media";
import { MediaType } from "../../generated/graphql";
import { useAppSelector } from "../../store";

export const Route = createFileRoute("/media/images/trash")({
  component: ImagesTrashPage,
});

function ImagesTrashPage() {
  const selectedFolderId = useAppSelector((state) => state.media.selectedFolderId);

  return (
    <div className="space-y-6 lg:p-[1%]">
      {/* Breadcrumbs */}
      <Breadcrumbs
        currentFolderId={selectedFolderId}
        mediaType={MediaType.Image}
        rootLabel="Images"
        showTrash={true}
      />

      {/* Trash View */}
      <TrashView folderId={selectedFolderId} mediaType={MediaType.Image} />
    </div>
  );
}
